import { LuLoaderCircle } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
// import { useIsCompactView } from "../../../core_stores/useIsCompactViewStore";
import { useProjectsMatchingSearchQuery } from "../../../core_stores/useProjectsListStore";
import {
  SideMenuBehavior,
  useSideMenuActions,
  useSideMenuBehavior,
  useSideMenuDropdownState,
  useSideMenuSelectedProjectId,
} from "../../../view_stores/useSideMenuStore";
import SideMenuProjectDropdownMenu from "./SideMenuProjectDropdownMenu";
import { typography } from "../../../design/tokens";

export default function SideMenuProjects() {
  const projectsMatchingSearchQuery = useProjectsMatchingSearchQuery();
  const { closeDropdown } = useSideMenuActions();
  const dropdownState = useSideMenuDropdownState();

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <h2 className={`${typography.size.sm} font-medium text-light-text dark:text-dark-text mb-2`}>
        Your Projects
      </h2>
      <div className="flex-1 space-y-1 overflow-y-auto pb-6">
        {projectsMatchingSearchQuery === null ? (
          <div className="flex justify-center items-center mt-4">
            <LuLoaderCircle className="animate-spin" size={24} />
          </div>
        ) : projectsMatchingSearchQuery.length > 0 ? (
          <ProjectsList />
        ) : (
          <div className="text-sm text-gray-400">No projects found</div>
        )}
      </div>
      <SideMenuProjectDropdownMenu
        projectId={dropdownState.projectId ?? ""}
        isOpen={dropdownState.isOpen}
        onClose={closeDropdown}
        position={dropdownState.position}
      />
    </div>
  );
}

function ProjectsList() {
  const projectsMatchingSearchQuery = useProjectsMatchingSearchQuery();
  const selectedProjectId = useSideMenuSelectedProjectId();
  const dropdownState = useSideMenuDropdownState();
  const sideMenuBehavior = useSideMenuBehavior();
  // const isCompactView = useIsCompactView();
  const navigate = useNavigate();

  const {
    setSelectedProjectId,
    close: closeSideMenu,
    // openDropdown,
  } = useSideMenuActions();

  function handleProjectClick(projectId: string) {
    if (projectId === selectedProjectId) {
      return;
    }
    setSelectedProjectId(projectId);
    if (sideMenuBehavior === SideMenuBehavior.AUTO) {
      window.dispatchEvent(new Event("darvin-block-reopen-menu"));
      closeSideMenu();
    }

    // Find project in list to get cached name for optimistic display
    const project = projectsMatchingSearchQuery?.find((p) => p.id === projectId);

    navigate(`/project/${projectId}`, {
      state: {
        projectId: projectId,
        projectName: project?.name || null,
      },
    });
  }

  // const handleMoreClick = (e: React.MouseEvent, projectId: string) => {
  //   e.stopPropagation();
  //   const rect = e.currentTarget.getBoundingClientRect();

  //   openDropdown(projectId, {
  //     x: isCompactView ? rect.right - 170 : rect.right + 12,
  //     y: isCompactView ? rect.top + 34 : rect.top - 8,
  //   });
  // };

  return projectsMatchingSearchQuery!.map((project) => (
    <div
      key={project.id}
      data-project-id={project.id}
      className={`side-menu-project-item ${
        selectedProjectId === project.id ||
        dropdownState.projectId === project.id
          ? "bg-[#B4B7CC] dark:bg-[#2A2E34] text-white"
          : "text-light-text dark:text-dark-text hover:bg-light-hover dark:hover:bg-dark-hover"
      } p-2 rounded-lg cursor-pointer ${typography.size.sm}
    mr-2 transition-colors flex items-center justify-between group`}
      onClick={() => handleProjectClick(project.id)}
    >
      <span className="flex-1 truncate">{project.name ?? project.id}</span>
      {/* <button
        className={`${
          selectedProjectId === project.id ||
          dropdownState.projectId === project.id
            ? "text-white"
            : "text-light-text dark:text-dark-text opacity-60 hover:opacity-100"
        } transition-opacity`}
        onClick={(e) => handleMoreClick(e, project.id)}
      >
        <LuEllipsis size={20} />
      </button> */}
    </div>
  ));
}
